import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SparkMD5 from 'spark-md5';
import { FormGroup, Label } from 'reactstrap';
import entityComposition from '../classes/entityComposition';
import signatureHandling from './signatureHandling';
import Signature from './signature';

// must be defined outside of the component to avoid re-rendering loops
const defaultOnChange = () => {};
const defaultOnUpload = () => {};
const SignatureInput = ({
  className: _className = '',
  penColor: _penColor = 'black',
  label: _label = null,
  onChange: _onChange = defaultOnChange,
  onUpload: _onUpload = defaultOnUpload,
  handleSignatureData: _handleSignatureData = null,
  disabled: _disabled = false,
  hasAppliedSignature: _hasAppliedSignature = false,
  notificationActions
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const handleChange = async signatureData => {
    if (!signatureData) {
      const change = _handleSignatureData || _onChange;
      change(null);
      return;
    }
    const signatureHash = SparkMD5.hash(signatureData);
    if (!_handleSignatureData) {
      // Control save functionality internally
      setIsLoading(true);
      _onUpload(true);
      try {
        const result = await signatureHandling.uploadSignature(signatureHash, signatureData);
        if (typeof result === 'string') {
          notificationActions.error({
            message: result
          });
          _onChange(null);
        } else {
          _onChange(result);
        }
      } catch (_unused) {
        notificationActions.error({
          message: 'There was a problem uploading the signature.'
        });
        _onChange(null);
      } finally {
        setIsLoading(false);
        _onUpload(false);
      }
    } else {
      // Expect parent component to handle saving correctly
      _handleSignatureData(signatureData, signatureHash);
    }
  };
  return /*#__PURE__*/React.createElement(FormGroup, {
    className: "signature-form"
  }, _label ? /*#__PURE__*/React.createElement(Label, null, _label) : null, /*#__PURE__*/React.createElement(Signature, {
    className: _className,
    penColor: _penColor,
    loading: isLoading,
    disabled: _disabled,
    hasAppliedSignature: _hasAppliedSignature,
    onChange: handleChange
  }));
};
SignatureInput.propTypes = {
  className: PropTypes.string,
  penColor: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onUpload: PropTypes.func,
  handleSignatureData: PropTypes.func,
  disabled: PropTypes.bool,
  hasAppliedSignature: PropTypes.bool,
  notificationActions: PropTypes.shape({
    error: PropTypes.func
  }).isRequired
};
export { SignatureInput as TestSignatureInput };
export default entityComposition(SignatureInput, [], {}, ['notification']);